<template>
    <select class="form-control" :value="value" @change="$emit('input', $event.target.value)">
        <option value="">— Välj typ —</option>
        <template v-for="(group, label) in types">
            <optgroup v-if="group.is_selectable" :key="label" :label="label">
                <option v-for="option in group.items" :key="option.handle" :value="option.handle">
                    {{ option.label }}{{ option.description ? ' - ' + option.description : '' }}
                </option>
            </optgroup>
        </template>
    </select>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: ''
        },
        types: {
            type: Object,
            default: () => ({})
        }
    }
}
</script>
